'use client';
import { ReactNode } from 'react';
import { Typography } from '@/app/common';
import { VIDEO_VARIANTS, VideoVariant } from '@workspace/constants';
import { cn } from '@/app/lib';

interface InfoCardProps {
  variant: VideoVariant;
  heading: string;
  description?: string;
  duration?: string;
  children?: ReactNode;
  wrapperClassName?: string;
  shouldRender?: boolean;
}

export function InfoCard({
  variant,
  heading,
  description,
  duration,
  children,
  wrapperClassName,
  shouldRender = true,
}: InfoCardProps) {
  if (!shouldRender) return null;

  return (
    <div className="flex flex-col w-full gap-12">
      <div
        className={cn(
          'flex flex-col gap-xs bg-white/80 rounded-lg p-6 z-10 md:p-lg md:w-149.75 md:gap-sm',
          wrapperClassName,
        )}
      >
        <div className="flex flex-col gap-xs md:gap-sm">
          {variant === VIDEO_VARIANTS.VideoWithText && duration && <Typography variant="bodySm">{duration}</Typography>}
          <Typography variant="h2" className="md:max-w-98 md:text-4xl text-2xl">
            {heading}
          </Typography>
          {variant === VIDEO_VARIANTS.ImageVideoWithText && description && (
            <Typography variant="bodySm" className="max-w-117.5">
              {description}
            </Typography>
          )}
        </div>
        {children}
      </div>
    </div>
  );
}
